import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import PlaceholderImg from "~/assets/userPlaceholder.webp";
import { getDemoEvaluation } from "~/modules/evalutation/services";
import type { Evaluation } from "~/modules/evalutation/types";

export const DemoCard: React.FC = () => {
	const [loading, setLoading] = useState<boolean>(true);
	const [data, setData] = useState<Evaluation>();

	useEffect(() => {
		const abortController = new AbortController();

		getDemoEvaluation(abortController)
			.then((d) => {
				d && setData(d);
			})
			.finally(() => {
				setLoading(false);
			});

		return () => {
			abortController.abort();
		};
	}, []);

	return data ? (
		<div className="flex flex-col w-full gap-4">
			<p className="text-center p-2 bg-gpa-blue-50 rounded-lg border border-gpa-blue-400">
				Você ainda pode ter uma demonstração do GPA ao visualizar um exemplo de
				avaliação para ter uma ideia melhor de como o GPA funciona.
			</p>
			<div className="grid grid-cols-[repeat(auto-fit,_minmax(_245px,324px))] justify-center grid-flow-row w-full gap-4">
				<div className="flex flex-col items-center h-[301px] p-4 rounded-2xl bg-white w-full gap-3">
					<div className="flex bg-white h-14 w-14 rounded-full overflow-hidden">
						<img
							src={PlaceholderImg}
							alt="face"
							loading="lazy"
							decoding="async"
							className="w-full h-full object-contain"
						/>
					</div>
					<div className="flex flex-1 items-center justify-end gap-2 flex-col">
						<h3 className="font-bold">{data.student.name}</h3>

						<div className="flex flex-col flex-1 justify-between">
							<p>
								Nesta demonstração você verá um exemplo de uma avaliação
								preenchida por completo
							</p>
							<Link
								to="/aluno/avaliacoes/demonstracao"
								className="text-gpa-blue-500"
								state={{ data }}
							>
								Visualizar Avaliação de demonstração
							</Link>
						</div>
						<div className="flex gap-2 flex-wrap items-end"></div>
					</div>
				</div>
			</div>
		</div>
	) : null;
};
